import React, { useEffect, useState } from 'react';
import "./Collaborator_fb.css";
import { Backtotop, Underline, Alertmessage } from '../../widgets';
import { collaboratorFeedbackQustions } from '../../constants/feedbackQuestions';
import axios from 'axios';
import { TextField, Autocomplete } from '@mui/material';


const Collaborator_fb = () => {
    const [projectName, setProjectName] = useState('');
    const [fundingAgency, setFundingAgency] = useState('');
    const [duration, setDuration] = useState('');
    const [principalInvigilator, setPrincipalInvigilator] = useState('');
    const [authorityName, setAuthorityName] = useState('');
    const [ratings, setRatings] = useState({});
    const [ratingErrors, setRatingErrors] = useState({});
    const [alertMessage, setAlertMessage] = useState('');
    const [nameError, setNameError] = useState('');

    useEffect(() => {
        document.title = 'ACGCET-Collaborator-Feedback';
    }, []);

    const validateRatings = () => {
        const errors = {};
        collaboratorFeedbackQustions.forEach(({ name }) => {
            if (!ratings[name]) {
                errors[name] = 'Please select a rating (தயவுசெய்து மதிப்பீட்டை தேர்வு செய்யவும்)';
            }
        });
        setRatingErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const validateName = (name) => {
        if (!name.trim()) {
            setNameError('Name of the authority is required');
            return false;
        } else {
            setNameError('');
            return true;
        }
    };

    const handleNameChange = (e) => {
        const name = e.target.value;
        validateName(name);
        setAuthorityName(name);
    };

    const handleRatingChange = (e, name) => {
        setRatings(prevRatings => ({
            ...prevRatings,
            [name]: parseInt(e.target.value, 10)
        }));
        setRatingErrors(prevErrors => ({
            ...prevErrors,
            [name]: '' // Clear the error once a rating is selected
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const areRatingsValid = validateRatings();
        const isNameValid = validateName(authorityName);

        if (!areRatingsValid || !isNameValid) {
            return;
        }

        try {
            const response = await axios.post('/backend/collaborator_ratingsubmit', {
                project_name: projectName,
                funding_agency: fundingAgency,
                duration: duration,
                principal_invigilator: principalInvigilator,
                authority_name: authorityName,
                ratings: ratings
            });

            console.log(response.data);
            setAlertMessage("Feedback submitted successfully");

            // Clear the form after submission
            setProjectName('');
            setFundingAgency('');
            setDuration('');
            setPrincipalInvigilator('');
            setAuthorityName('');
            setRatings({});
            setRatingErrors({});
        } catch (error) {
            console.error('Error:', error);
            setAlertMessage("An error occurred while submitting your ratings");
        }
    };

    const handleCloseAlert = () => setAlertMessage('');

    return (
        <div className='collab_fb_body'>
            <Underline heading="Collaborator Feedback"></Underline>
            <form action="" className='collab_fb_form' onSubmit={handleSubmit}>
                <div className="collab_fb_row">
                    <TextField
                        className="collab_fb_input"
                        label='Name of the project'
                        value={projectName}
                        onChange={(e) => setProjectName(e.target.value)}
                        required
                    />
                    <TextField
                        className="collab_fb_input"
                        label='Funding Agency'
                        value={fundingAgency}

                        onChange={(e) => {
                            const input = e.target.value;
                            if (input.length <= 255) {
                                setFundingAgency(input);
                            } else {
                                setFundingAgency(input.slice(0, 255)); // Prevents extra chars
                            }
                        }}
                        required
                    />
                </div>

                <div className="collab_fb_row">
                    <TextField
                        className='collab_fb_input'
                        label='Duration'
                        value={duration}

                        onChange={(e) => {
                            const input = e.target.value;
                            if (input.length <= 100) {
                                setDuration(input);
                            } else {
                                setDuration(input.slice(0, 100)); // Prevents extra chars
                            }
                        }}
                        required
                    />
                    <TextField
                        className='collab_fb_input'
                        label='Principal Investigator'
                        value={principalInvigilator}

                        onChange={(e) => {
                            const input = e.target.value;
                            if (input.length <= 255) {
                                setPrincipalInvigilator(input);
                            } else {
                                setPrincipalInvigilator(input.slice(0, 255)); // Prevents extra chars
                            }
                        }}

                        required
                    />
                </div>

                <div className="collab_fb_row">
                    <TextField
                        className="collab_fb_input_lgrow"
                        label='Name of the authority'
                        value={authorityName}
                        onChange={handleNameChange}
                        required
                    />
                    {nameError && <p className='collab_fb_name_error'>{nameError}</p>}
                </div>

                <h2 className="collab_fb_subheading">Please give your valuable feedback on a scale</h2>

                <div className="collab_fb_instructions">
                    5 - Excellent,   4 - Good,   3 - Satisfied,   2 - Not Satisfied,   1 - Poor
                </div>

                <div className="collab_fb_map">
                    {collaboratorFeedbackQustions.map(({ question, translation, name }) => (
                        <div className="collab_fb_question" key={name}>
                            <p>{question}</p>
                            <p>({translation})</p>
                            <div className="collab_fb_ratings">
                                {[1, 2, 3, 4, 5].map(num => (
                                    <label key={num}>
                                        <input
                                            type="radio"
                                            name={name}
                                            value={num}
                                            onChange={(e) => handleRatingChange(e, name)}
                                            checked={ratings[name] === num}
                                            required
                                        />
                                        <span className="custom-radio">{num}</span>
                                    </label>
                                ))}
                            </div>
                            {ratingErrors[name] && <p className='collab_fb_error'>{ratingErrors[name]}</p>}
                        </div>
                    ))}
                </div>

                <div className="collab_fb_btn">
                    <button type='submit' className='collab_fb_submit'>
                        Submit
                    </button>
                </div>
            </form>
            <Backtotop />
            <Alertmessage message={alertMessage} onClose={handleCloseAlert} />
        </div>
    );
};

export default Collaborator_fb;
